export const SEARCH_MOVIE = 'SEARCH_MOVIE';
export const FETCH_MOVIES = 'FETCH_MOVIES';
export const FETCH_MOVIE = 'FETCH_MOVIE';
export const LOADING = 'LOADING';
export const GET_MOVIE = 'GET_MOVIE';
export const EMPTY_PRED_MOVIES = 'EMPTY_PRED_MOVIES';
export const EMPTY_USER_MOVIES='EMPTY_USER_MOVIES';
export const USER_ID= 'USER_ID';
export const USER_BOOKS='USER_BOOKS';
export const EMPTY_BOOKS='EMPTY_BOOKS';
export const GET_BOOK='GET_BOOK';
export const EMPTY_PRED_BOOKS = 'EMPTY_PRED_BOOKS';



// WEBPACK FOOTER //
// ./src/actions/types.js